/**
 * The tab bar on a phone: Overview, Organizations, Search, Create and the
 * console's pages — within a thumb's reach, since the top bar is not.
 *
 * Hidden above 640px by CSS. Nothing here is phone-only: each button opens
 * the same page, command center, create menu or navigation the desktop
 * reaches from the top bar.
 */
import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Icon } from '../components/Icon.jsx';
import { Modal } from '../components/Modal.jsx';
import { QuickCreateMenu } from './QuickCreate.jsx';

export function MobileNav({ onOpenCommand, onOpenNav, moduleRequests = 0 }) {
  const [creating, setCreating] = useState(false);
  const { pathname } = useLocation();
  const atHome = pathname === '/';
  const atOrganizations = pathname === '/organizations' || /^\/organizations\/(?!new$)[^/]+$/.test(pathname);

  return (
    <>
      <nav className="mobilenav" aria-label="Quick navigation">
        <Link to="/" className={`mobilenav-item ${atHome ? 'is-active' : ''}`} aria-current={atHome ? 'page' : undefined}>
          <Icon name="overview" size={20} />
          <span>Overview</span>
        </Link>
        <Link
          to="/organizations"
          className={`mobilenav-item ${atOrganizations ? 'is-active' : ''}`}
          aria-current={atOrganizations ? 'page' : undefined}
        >
          <Icon name="organization" size={20} />
          <span>Orgs</span>
        </Link>
        <button type="button" className="mobilenav-item" onClick={onOpenCommand}>
          <Icon name="search" size={20} />
          <span>Search</span>
        </button>
        <button type="button" className="mobilenav-item" onClick={() => setCreating(true)}>
          <Icon name="plus" size={20} />
          <span>Create</span>
        </button>
        <button
          type="button"
          className="mobilenav-item"
          onClick={onOpenNav}
          aria-label={moduleRequests > 0 ? `Console pages, ${moduleRequests} module requests waiting` : 'Console pages'}
        >
          <Icon name="menu" size={20} />
          <span>Menu</span>
          {moduleRequests > 0 && <span className="mobilenav-dot" aria-hidden="true" />}
        </button>
      </nav>

      {creating && (
        <Modal open onClose={() => setCreating(false)} title="Create">
          <div
            onClick={(event) => {
              if (event.target.closest('a')) setCreating(false);
            }}
            role="presentation"
          >
            <QuickCreateMenu />
          </div>
        </Modal>
      )}
    </>
  );
}
